import React from 'react';
import {useFormContext, useWatch} from "react-hook-form";
import FormField from "../../../../../components/react-hook-form/form-field.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";

const BoFormIndividualSelect = ({ name, classNameWrapper }) => {
    const { control } = useFormContext();

    const individualList = useWatch({
        control,
        name: "individualList",
        defaultValue: []
    });

    const options = individualList.map((individuo, index) => ({
        value: individuo.itemId,
        label: individuo.name || `Indivíduo - ${index + 1}`
    }));

    return (
        <FormField
            name={name}
            customRender={(field) => (
                <SelectComponent
                    instanceId={name}
                    value={options.find(opt => opt.value === field.value) ?? null}
                    options={options}
                    label={"Indivíduo"}
                    classNameWrapper={classNameWrapper}
                    onChange={(selected) => field.onChange(selected?.value ?? null)}
                />
            )}
        />
    );
};

export default BoFormIndividualSelect;